// GENERATED FILE - DO NOT MODIFY

export enum CompanyRoleDto {
    Member = "Member",
    BookingManager = "BookingManager",
    Administrator = "Administrator",
}